import { render, staticRenderFns } from "./YearsDateSelector.vue?vue&type=template&id=2e23767e&scoped=true"
import script from "./YearsDateSelector.vue?vue&type=script&lang=ts"
export * from "./YearsDateSelector.vue?vue&type=script&lang=ts"
import style0 from "./YearsDateSelector.vue?vue&type=style&index=0&id=2e23767e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23767e",
  null
  
)

export default component.exports